// El backend manda y recibe SIEMPRE centavos enteros. Estas son las únicas
// conversiones permitidas en el frontend.

export const formatMoney = (cents, currency = "DOP") =>
  new Intl.NumberFormat("es-DO", {
    style: "currency",
    currency,
  }).format((Number(cents) || 0) / 100);

/** "5250.00" -> 525000 */
export const amountToCents = (amount) =>
  Math.round((Number(amount) || 0) * 100);

/** 525000 -> "5250.00" (para rellenar un input) */
export const centsToAmount = (cents) =>
  ((Number(cents) || 0) / 100).toFixed(2);
